import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { connect } from "react-redux";
import { Routes } from "react-router";
import { Route } from "react-router-dom";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { thunkGetBonusPointsInfo, thunkGetCustomerHistory } from "../../store/actions/BonifiedInteractionsActions";
import { thunkFindActivePremiums } from "../../store/actions/BonusPremiumActions";
import { thunkFindCoupons } from "../../store/actions/CouponActions";
import { thunkFindCustomer } from "../../store/actions/CustomerActions";
import { thunkGetCustomerPreferences } from "../../store/actions/CustomerPreferencesActions";
import { thunkGetBranchStoreList, thunkGetOperationalRootUnitList } from "../../store/actions/OperationalUnitActions";
import { thunkGetRegistrationFieldConfig } from "../../store/actions/RegistrationActions";
import { IStore } from "../../store/rootReducer";
import {
  isUnauthenticatedPath,
  UrlPathBlockCustomer,
  UrlPathBonifiedInteractions,
  UrlPathBonusPremium,
  UrlPathConsent,
  UrlPathCoupon,
  UrlPathCouponTemplates,
  UrlPathCustomer,
  UrlPathCustomerPreferences,
  UrlPathInviteFamily,
  UrlPathInviteFriend,
  UrlPathMain,
  UrlPathRegistration,
  UrlPathSimulator,
  UrlPathReceipts,
  UrlPathGameZone,
  UrlPathMissionCenter,
} from "../../url";
import BlockCustomerPage from "../blockCard/BlockCustomerPage";
import BonifiedInteractionsPage from "../bonifiedInteractions/BonifiedInteractionsPage";
import BonusPremiumPage from "../bonusPremium/BonusPremiumPage";
import ConsentPage from "../consent/ConsentPage";
import CouponPage from "../coupon/CouponPage";
import CouponTemplatesPage from "../coupon/CouponTemplatesPage";
import CustomerPage from "../customer/CustomerPage";
import CustomerPreferencesPage from "../customerPreferences/CustomerPreferencesPage";
import InviteFamilyPage from "../inviteFamily/InviteFamilyPage";
import InviteFriendPage from "../inviteFriend/InviteFriendPage";
import RegistrationPage from "../registration/RegistrationPage";
import CashDeskSimulatorPage from "../simulator/CashDeskSimulatorPage";
import MyReceiptsPage from "../receipts/MyReceiptsPage";
import WelcomePage from "../welcome/WelcomePage";
import { GameZonePage, MissionCenterPage } from "../gamification";

const App = (props: ThunkProps) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    keycloak.onAuthSuccess = () => {
      const {
        thunkFindCustomer,
        thunkGetCustomerPreferences,
        thunkGetCustomerHistory,
        thunkGetBonusPointsInfo,
        thunkFindCoupons,
        thunkFindActivePremiums,
        thunkGetOperationalRootUnitList,
        thunkGetBranchStoreList,
      } = props;
      thunkGetCustomerPreferences();
      thunkFindCustomer();
      thunkGetCustomerHistory();
      thunkGetBonusPointsInfo();
      thunkFindCoupons(false);
      thunkFindActivePremiums();
      thunkGetOperationalRootUnitList();
      thunkGetBranchStoreList();
    };

    keycloak.onAuthLogout = () => {
      keycloak.login();
    };
  }, [keycloak, props]);

  useEffect(() => {
    if (isUnauthenticatedPath()) {
      props.thunkGetRegistrationFieldConfig();
      props.thunkGetBranchStoreList();
    }
  }, [props]);

  if (!initialized) {
    return <></>;
  }

  if (!keycloak.authenticated && !isUnauthenticatedPath()) {
    keycloak.login();
    return <></>;
  }

  return (
    <Routes>
      <Route path={UrlPathMain} element={keycloak.authenticated ? <CustomerPage /> : <WelcomePage />} />
      <Route path={UrlPathCustomer} element={<CustomerPage />} />
      <Route path={UrlPathCustomerPreferences} element={<CustomerPreferencesPage />} />
      <Route path={UrlPathBonifiedInteractions} element={<BonifiedInteractionsPage />} />
      <Route path={UrlPathCoupon} element={<CouponPage />} />
      <Route path={UrlPathCouponTemplates} element={<CouponTemplatesPage />} />
      <Route path={UrlPathBonusPremium} element={<BonusPremiumPage />} />
      <Route path={UrlPathSimulator} element={<CashDeskSimulatorPage />} />
      <Route path={UrlPathReceipts} element={<MyReceiptsPage />} />
      <Route path={UrlPathGameZone} element={<GameZonePage />} />
      <Route path={UrlPathMissionCenter} element={<MissionCenterPage />} />
      <Route path={UrlPathInviteFamily} element={<InviteFamilyPage />} />
      <Route path={UrlPathInviteFriend} element={<InviteFriendPage />} />
      <Route path={UrlPathRegistration} element={<RegistrationPage />} />
      <Route path={UrlPathConsent} element={<ConsentPage />} />
      <Route path={UrlPathBlockCustomer} element={<BlockCustomerPage />} />
    </Routes>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      thunkGetCustomerPreferences,
      thunkFindCustomer,
      thunkGetCustomerHistory,
      thunkGetBonusPointsInfo,
      thunkFindCoupons,
      thunkFindActivePremiums,
      thunkGetOperationalRootUnitList,
      thunkGetBranchStoreList,
      thunkGetRegistrationFieldConfig,
    },
    dispatch
  );

type ThunkProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (_state: IStore) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
